import logo from '../../assets/img/logo-01.png';
import {Link} from 'react-router-dom';

function Footer() {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <footer className="ltn__footer-area  ">
      <div className="footer-top-area  section-bg-2 plr--5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-3 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-about-widget">
                <div className="footer-logo">
                  <div className="site-logo">
                    <img src={logo} alt="Logo" />
                  </div>
                </div>
                <p>
                  We provide personal and complex care in Worcestershire,
                  England.
                </p>
                <div className="footer-address">
                  <ul>
                    <li>
                      <div className="footer-address-icon">
                        <i className="icon-placeholder"></i>
                      </div>
                      <div className="footer-address-info">
                        <p>25 Port Street Evesham WR11 3LD</p>
                      </div>
                    </li>
                    <li>
                      <div className="footer-address-icon">
                        <i className="icon-call"></i>
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <a href="tel:+44 01386 424639  ">+44 01386 424639 </a>
                        </p>
                      </div>
                    </li>
                    <li>
                      <div className="footer-address-icon">
                        <i className="icon-mail"></i>
                      </div>
                      <div className="footer-address-info">
                        <p>
                          <a href="mailto:info@qualityhealth.org.uk">
                            info@qualityhealth.org.uk
                          </a>
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="ltn__social-media mt-20">
                  <ul>
                    <li>
                      <Link className="top-a" to="#" title="Facebook">
                        <i className="fab fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link className="top-a" to="#" title="Twitter">
                        <i className="fab fa-twitter"></i>
                      </Link>
                    </li>

                    <li>
                      <Link className="top-a" to="#" title="Instagram">
                        <i className="fab fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-menu-widget clearfix">
                <h4 className="footer-title">About us</h4>
                <div className="footer-menu">
                  <ul>
                    <li>
                      <Link to="/about-quality">About Quality</Link>
                    </li>
                    <li>
                      <Link to="/our-services">Our services</Link>
                    </li>
                    <li>
                      <Link to="/supported-living">Supported living</Link>
                    </li>
                    <li>
                      <Link to="/find-a-home">Find a home</Link>
                    </li>
                    <li>
                      <Link to="/consultation">Consultation</Link>
                    </li>
                    <li>
                      <Link to="/team">Our team</Link>
                    </li>
                    <li>
                      <Link to="/how-we-deliver">How we deliver our care</Link>
                    </li>
                    <li>
                      <Link to="/excellence">
                        Quality and clinical excellence
                      </Link>
                    </li>
                    <li>
                      <Link to="/values">Our values</Link>
                    </li>
                    <li>
                      <Link to="/work-with">Who we work with</Link>
                    </li>
                    <li>
                      <Link to="/funding">Funding your care</Link>
                    </li>
                    <li>
                      <Link to="/testimonials">Testimonials</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-menu-widget clearfix">
                <h4 className="footer-title">Our care</h4>
                <div className="footer-menu">
                  <ul>
                    <li>
                      <Link to="/spinal-injury">Spinal injury</Link>
                    </li>
                    <li>
                      <Link to="/brain-injury">Brain injury</Link>
                    </li>
                    <li>
                      <Link to="/airway-management">
                        Ventilation and airway management
                      </Link>
                    </li>
                    <li>
                      <Link to="/learning-disability">Learning Disability</Link>
                    </li>
                    <li>
                      <Link to="/nursing-care">Nursing Care</Link>
                    </li>
                    <li>
                      <Link to="/neurological-conditions">
                        Degenerative and Neurological Conditions
                      </Link>
                    </li>
                    <li>
                      <Link to="/children">Children and Young People</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 col-sm-6 col-12">
              <div className="footer-widget footer-menu-widget clearfix">
                <h4 className="footer-title">Work with us</h4>
                <div className="footer-menu">
                  <ul>
                    <li>
                      <Link to="/vacancies">Vacancies</Link>
                    </li>
                    <li>
                      <Link to="/recruitment-process">Recruitment Process</Link>
                    </li>
                    <li>
                      <Link to="/work-with-us">
                        Working For Quality Healthcare
                      </Link>
                    </li>
                    <li>
                      <Link to="/values">Our Core Values</Link>
                    </li>
                    <li>
                      <Link to="/training">Training and Development</Link>
                    </li>
                    <li>
                      <Link to="/reward">Reward and Recognition</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ltn__copyright-area ltn__copyright-2 section-bg-7  plr--5">
        <div className="container-fluid ltn__border-top-2">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="ltn__copyright-design clearfix">
                <p>
                  All Rights Reserved @ Quality healthcare & home services.
                  <span className="current-year">{year}</span>
                </p>
              </div>
            </div>
            <div className="col-md-6 col-12 align-self-center">
              <div className="ltn__copyright-menu text-end">
                <ul>
                  <li></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
